<script setup lang="ts">
import type { PageType } from '~/types/Page';
import {endpoints} from "~/constants/endpoints";
import ContactUs from '@/components/custom-ui/ContactUs.vue'

definePageMeta({
  name: 'page',
})

const route = useRoute()
const page_id = Array.isArray(route.params?.id) ? route.params.id[0] : route.params?.id;
const config = useRuntimeConfig()

const { data: page } = await useAsyncData<PageType>(`page_${page_id}`, () => getPage(page_id))

async function getPage(documentId: string){
    return await fetchData<PageType>(endpoints.pages.getById(documentId), {
        method: "GET",
    }).then(({data, meta}) => {
        console.log(data)
        return data
    })
}

useSeoMeta({
    robots: 'index, follow',
    title: page.value?.name,
    ogUrl: () => config.public.frontUrl + route.path,
    ogTitle: () => page.value?.name,
    twitterTitle: () => page.value?.name,
})

useHead({
    link: [
        {
            rel: 'canonical',
            href: config.public.frontUrl + route.path,
        },
    ],
})

const { parseMarkdown } = useMarkdown()
const parsedContent = computed(() => parseMarkdown(page.value?.text))

</script>

<template>
  <div class="container mx-auto px-4 h-full">
    <div class="min-h-screen flex flex-col">
      <div class="flex-grow">

        <div v-if="page?.name" class="my-16 flex items-center justify-center ys-about-card-end mx-4">
          <div class="grid place-items-center">
            <h1 class="ys-description-text mb-4">
              <Icon size="24" class="menu-item-icon mr-1 text-gray-500" name="ri:home-smile-2-line"/>
            </h1>
            <h1 class="ys-logo-text mb-6 text-3xl font-normal leading-9">
              {{ page?.name }}
            </h1>
            <NuxtImg src="SupportPage/books.png" width="166" height="84" />
          </div>
        </div>

        <div v-if="parsedContent" class="my-16 max-w-[900px] mx-auto">
          <div class="page_content" v-html="parsedContent"></div>
        </div>
        <ContactUs/>
      </div>
    </div>
  </div>
</template>


<style scoped lang="scss">

.ys-about-card-end {
  height: 261px;
  border-radius: 36px;
  background: rgba(247, 254, 248, 1);
}


.ys-logo-text {
  font-family: Involve, sans-serif;
  color: rgba(0, 0, 0, 1);
  font-size: 34px;
  font-weight: 500;
  line-height: 34px;
}

.ys-title-text {
  font-family: Inter, sans-serif;
  color: rgba(10, 13, 20, 1);
  font-size: 18px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: -0.015em;
  text-align: left;
}

.ys-description-text {
  font-family: Inter, sans-serif;
  color: rgba(10, 13, 20, 1);
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: -0.015em;
  text-align: left;
}

</style>